/**
 * Small utility function that sets the Browser's tab title.
 * @param {string} title 
 * The title to be displayed in the browser tab
 */
const setDocumentTitle = (title: string) => {

	document.title = title
}

export default setDocumentTitle
